<script>
import VProgressLog from "./components/VProgressLog";
import VProjectActions from "./components/VProjectActions";
import VActionableActions from "./components/VActionableActions.vue";
import VPmNotes from "./components/VPmNotes";
import VImportantDates from "./components/VImportantDates";
import { EventBus } from "@/libraries/EventBus";

export default {
    props: {
        project_id: {}
    },
    components: {
        VProgressLog,
        VProjectActions,
        VPmNotes,
        VImportantDates,
        VActionableActions
    },
    methods: {
        eventize(type) {
            if (type === "open") {
                EventBus.$emit("data-tab-open");
            } else {
                EventBus.$emit("data-tab-close");
            }
        }
    }
};
</script>

<template>
    <div>
        <base-header class="pb-1" type="">
            <bread-bag>
                <base-button @click="eventize('open')" type="primary" size="sm"
                    ><i class="far fa-plus"></i>
                    {{ $t("milestones.expand_all") }}</base-button
                ><base-button
                    @click="eventize('close')"
                    type="primary"
                    size="sm"
                    ><i class="far fa-minus"></i>
                    {{ $t("milestones.fold_all") }}</base-button
                ></bread-bag
            >
        </base-header>

        <v-important-dates :project_id="project_id" />

        <v-actionable-actions :project_id="project_id" />

        <v-project-actions :project_id="project_id" />

        <v-pm-notes :project_id="project_id" v-if="true" />

        <v-progress-log :project_id="project_id" v-if="true" />
    </div>
</template>
